module.exports = {
          srcSet: __webpack_public_path__ + "ae1e0ced51df4a0f8ae50ff0c50eff03-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "ae1e0ced51df4a0f8ae50ff0c50eff03-1168.png",width: 1168,height: 248}],
          src: __webpack_public_path__ + "ae1e0ced51df4a0f8ae50ff0c50eff03-1168.png",
          toString:function(){return __webpack_public_path__ + "ae1e0ced51df4a0f8ae50ff0c50eff03-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ABlQNvwsZkr+K25O/SNwS/0HYzf9C2Q5/T58W/0AUiz9W1dB/i9RM/oAECwf/BUyJP4OLR7+EjEi/g4wIP4SKBr+dzk7/jpMQv6dNjv/u2Bc/FDWIfqRS41UAAAAAElFTkSuQmCC",
          width: 1168,
          height: 248
        }